// src/utils/userDoc.js
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { firebaseApp } from "../firebase/firebaseApp";

const db = getFirestore(firebaseApp);

/** Always writes to lungform_users/{uid} with merge:true */
export async function upsertUserDoc(uid, data) {
  if (!uid) throw new Error("upsertUserDoc requires a uid");
  await setDoc(doc(db, "lungform_users", uid), data, { merge: true });
}

/** Optional: migrate legacy doc keyed by email → uid (merge then delete) */
export async function migrateLegacyDocIfAny(uid, email) {
  if (!uid || !email) return;
  const legacyRef = doc(db, "lungform_users", email);
  const legacySnap = await getDoc(legacyRef);
  if (!legacySnap.exists()) return;
  const legacyData = legacySnap.data();
  await setDoc(doc(db, "lungform_users", uid), legacyData, { merge: true });
  await deleteDoc(legacyRef);
}
